"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomValidator = void 0;
var isCustomValidator = function (value, customValidator) {
    try {
        return customValidator(value);
    }
    catch (error) {
        throw new Error("custom validator failed");
    }
};
exports.isCustomValidator = isCustomValidator;
//# sourceMappingURL=isCustomValidator.js.map